import { useState, useEffect } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    axios.get(`${API}/faq`).then(r => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-16" data-testid="faq-page">
      <section className="bg-navy py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-gold font-body mb-3">Help Center</p>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white mb-4">Frequently Asked Questions</h1>
          <p className="text-lg text-white/80 font-body">Find answers to common questions about Safe Florida and membership.</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          {faqs.length === 0 ? (
            <div className="text-center py-16">
              <HelpCircle className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500 font-body">FAQs are being prepared.</p>
            </div>
          ) : (
            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <div key={faq.id} className="border border-gray-200 rounded-lg overflow-hidden" data-testid={`faq-item-${i}`}>
                  <button onClick={() => setOpen(open === i ? null : i)}
                    className="w-full flex items-center justify-between p-5 text-left hover:bg-navy/5 transition-colors">
                    <h3 className="font-heading font-bold text-navy text-base pr-4">{faq.question}</h3>
                    <ChevronDown className={`w-5 h-5 text-navy flex-shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
                  </button>
                  {open === i && (
                    <div className="px-5 pb-5 animate-fade-in">
                      <p className="text-sm text-gray-700 font-body leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
